/**
 * Featured Product Gallery - Self-contained controller
 * Uses ResizeObserver for accurate mobile measurement
 */
(function () {
  const INTERVAL_MS = 3000;

  function initAutoplay(gallery) {
    const sliderComponent = gallery.querySelector('slider-component');
    const sliderList = gallery.querySelector('.product__media-list');
    const slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    const thumbButtons = Array.from(gallery.querySelectorAll('.thumbnail-list__item button.thumbnail'));
    const nextBtn = gallery.querySelector('.slider-button--next');
    const prevBtn = gallery.querySelector('.slider-button--prev');

    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;
    let slideWidth = 0;

    function applyStyles() {
      sliderList.style.display = 'flex';
      sliderList.style.flexWrap = 'nowrap';
      sliderList.style.overflow = 'visible';
      sliderList.style.margin = '0';
      sliderList.style.padding = '0';
      sliderList.style.gap = '0';
      sliderComponent.style.overflow = 'hidden';
      sliderComponent.style.display = 'block';
    }

    function updateSlideWidth(w) {
      slideWidth = w;
      slides.forEach(slide => {
        slide.style.cssText += `width:${w}px !important; min-width:${w}px !important; max-width:${w}px !important; flex-shrink:0 !important;`;
      });
    }

    function goTo(index, animate) {
      index = ((index % slides.length) + slides.length) % slides.length;
      current = index;
      sliderList.style.transition = animate === false ? 'none' : 'transform 0.4s ease';
      sliderList.style.transform = `translateX(-${slideWidth * current}px)`;
      slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
      thumbButtons.forEach((btn, i) => {
        btn.toggleAttribute('aria-current', i === current);
        if (i === current) btn.setAttribute('aria-current', 'true');
        else btn.removeAttribute('aria-current');
      });
    }

    function startTimer() {
      timer = setInterval(() => goTo(current + 1, true), INTERVAL_MS);
    }

    function resetTimer() {
      clearInterval(timer);
      startTimer();
    }

    applyStyles();

    // ResizeObserver fires whenever the container actually changes size
    // This is the most reliable way to get accurate width on mobile
    let initialized = false;
    const ro = new ResizeObserver(entries => {
      const w = entries[0].contentRect.width;
      if (w === 0) return;
      updateSlideWidth(w);
      goTo(current, false);
      if (!initialized) {
        initialized = true;
        setTimeout(startTimer, 800);
      }
    });
    ro.observe(sliderComponent);

    if (nextBtn) nextBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      goTo(current + 1, true);
      resetTimer();
    });

    if (prevBtn) prevBtn.addEventListener('click', (e) => {
      e.stopImmediatePropagation();
      goTo(current - 1, true);
      resetTimer();
    });

    thumbButtons.forEach((btn, i) => {
      btn.addEventListener('click', (e) => {
        e.stopImmediatePropagation();
        goTo(i, true);
        resetTimer();
      });
    });

    gallery.addEventListener('mouseenter', () => clearInterval(timer));
    gallery.addEventListener('mouseleave', startTimer);
  }

  function init() {
    document.querySelectorAll('.featured-product media-gallery').forEach(initAutoplay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
